import { CloseOutlined, DeleteOutlined } from '@ant-design/icons';
import { Heading } from '@mm/components';
import { Switch } from 'antd';
import { useChatStartersCRUDActions } from '@mm/state/actions/ChatStartersCRUDActinos';
import { usePromoterCRUDActions } from '@mm/state/actions/PromoterCRUDActions';
import { useViewActions } from '@mm/state/actions/viewActions';
import { PromoterModel } from '@mm/state/model/PromoterModel';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { useDeleteChatStarter } from '../../../../features/beta/modules/ChatStarters/use-delete-chat-starter';
import styles from './PromoterHeader.module.css';
import { useDeleteAutomationTrigger } from '../../../../features/beta/modules/Automations/AutomationEdit/InputTriggers/use-delete-automation-trigger';

type Props = {
  promoter: PromoterModel;
  title: string;
  customActivateAction?: () => void;
  hideDeleteAction?: boolean;
  className?: string;
  deleteWithPromoterCRUDAction?: boolean;
};

export const PromoterHeader = (props: Props) => {
  const {
    promoter,
    title,
    customActivateAction,
    hideDeleteAction,
    className,
    deleteWithPromoterCRUDAction = false,
  } = props;
  const promoterCRUDActions = usePromoterCRUDActions();
  const chatbotId = useSelector(activeChatbotIdSelector);
  const viewActions = useViewActions();
  const { deleteChatStarter } = useDeleteChatStarter(
    deleteWithPromoterCRUDAction,
  );

  const { automationId, handleDelete } = useDeleteAutomationTrigger();

  const { retrieveAll } = useChatStartersCRUDActions();

  const onClickActivate = async () => {
    if (customActivateAction) {
      return customActivateAction();
    }
    await promoterCRUDActions.update(chatbotId, {
      id: promoter.id,
      active: !promoter.active,
    });
    await retrieveAll({
      botId: chatbotId,
      kind: promoter.type,
    });
  };

  const onClickDelete = async () => {
    if (!promoter?.id) {
      return;
    }

    if (!automationId) {
      await deleteChatStarter(promoter as any);
      await retrieveAll({
        botId: chatbotId,
        kind: promoter.type,
      });
    }

    if (automationId) {
      const name = title || promoter?.name || '';
      await handleDelete('promoter', promoter.id, name);
    }

    viewActions.hideSlideoutMenu();
  };

  return (
    <div className={classNames(styles.promoterHeaderBlock, className)}>
      <div className={styles.promoterHeaderContent}>
        <Heading className={styles.promoterHeaderTitle} size={3}>
          {title}
        </Heading>
        <div className={styles.promoterHeaderButtons}>
          <Switch
            checkedChildren="active"
            unCheckedChildren="paused"
            checked={promoter.active}
            onChange={onClickActivate}
            className={styles.switch}
          />
          {!hideDeleteAction && (
            <DeleteOutlined
              className={styles.promoterHeaderDeleteButton}
              onClick={onClickDelete}
            />
          )}

          <CloseOutlined
            className={styles.closeIcon}
            onClick={viewActions.hideSlideoutMenu}
          />
        </div>
      </div>
    </div>
  );
};
